import type {
  DocumentData,
  SnapshotOptions,
  QueryDocumentSnapshot,
  FirestoreDataConverter,
  Timestamp,
  WithFieldValue,
} from 'firebase/firestore';

import { Message } from '@/slw/entities/chat';

export const messageConverter: FirestoreDataConverter<Message> = {
  toFirestore({
    chatId,
    senderId,
    text,
    imgUrls,
    createdAt,
    senderName,
    avatar,
    id,
    listingData,
  }: WithFieldValue<Message>): DocumentData {
    return {
      chatId,
      senderId,
      text,
      imgUrls,
      createdAt,
      senderName,
      avatar,
      id,
      listingData,
    };
  },
  fromFirestore(snapshot: QueryDocumentSnapshot, options: SnapshotOptions): Message {
    const { chatId, senderId, text, imgUrls, id, createdAt, senderName, avatar, listingData } = snapshot.data(
      options,
    ) as Omit<Message, 'createdAt' | 'editedAt'> & {
      createdAt: Timestamp;
    };

    return {
      chatId,
      name,
      text,
      senderId,
      imgUrls,
      createdAt,
      senderName,
      avatar,
      id,
      listingData,
    };
  },
};
